import type { ReportData } from '@/lib/types';

interface ReportHeaderProps {
  report: ReportData;
}

export function ReportHeader({ report }: ReportHeaderProps) {
  return (
    <div className="glass-panel p-6 px-7 max-[760px]:p-5">
      <div className="flex items-start gap-4 mb-5 max-[760px]:flex-col max-[760px]:gap-2">
        <div className="flex-1 min-w-0">
          <p className="text-[18px] font-light tracking-[-0.01em] leading-none">
            <span className="opacity-90">Optimal</span>
            <span className="font-bold ml-px">Health</span>
          </p>
        </div>
      </div>
      <div className="flex flex-wrap items-end justify-between gap-6 max-[760px]:gap-4">
        <div className="flex-1 min-w-0">
          <h1 className="text-[24px] font-bold tracking-[-0.018em] leading-[1.15] m-0">
            {report.patientName}
          </h1>
          <p className="text-[13px] text-tertiary mt-1.5 leading-[1.4]">
            {report.patientAge} años · {report.patientGender} · {report.patientCity}
          </p>
        </div>
        <dl className="flex gap-7 max-[760px]:gap-5 m-0">
          <ReportMeta label="Fecha de proceso" value={report.processedAt} />
          <ReportMeta label="Fecha de captura" value={report.collectedAt} />
          <ReportMeta label="ID de reporte" value={report.id} mono />
        </dl>
      </div>
    </div>
  );
}

interface ReportMetaProps {
  label: string;
  value: string;
  mono?: boolean;
}

function ReportMeta({ label, value, mono }: ReportMetaProps) {
  return (
    <div>
      <dt className="text-[10px] font-semibold tracking-[0.06em] uppercase text-muted m-0 mb-1">
        {label}
      </dt>
      <dd className={`text-[13px] font-semibold text-secondary m-0 tnum ${mono ? 'tracking-[0.005em]' : ''}`}>
        {value}
      </dd>
    </div>
  );
}
